type GroupName =
  | 'INLINE_STYLE_BUTTONS'
  | 'BLOCK_TYPE_BUTTONS'
  | 'LINK_BUTTONS'
  | 'BLOCK_TYPE_DROPDOWN'
  | 'HISTORY_BUTTONS'
  | 'IMAGE_BUTTON';

interface StyleConfig {
  label: string;
  style: string;
  className?: string;
}

type StyleConfigList = StyleConfig[];

interface ToolbarConfig {
  display: GroupName[];
  extraProps?: object;
  INLINE_STYLE_BUTTONS: StyleConfigList;
  BLOCK_TYPE_DROPDOWN: StyleConfigList;
  BLOCK_TYPE_BUTTONS: StyleConfigList;
}

export const RTE_TOOLBARCONFIG: ToolbarConfig = {
  BLOCK_TYPE_BUTTONS: [
    { label: 'UL', style: 'unordered-list-item' },
    { label: 'OL', style: 'ordered-list-item' },
    { label: 'Blockquote', style: 'blockquote' }
  ],
  BLOCK_TYPE_DROPDOWN: [
    { label: 'Normal', style: 'unstyled' },
    { label: 'Heading Small', style: 'header-three' }
  ],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
    { label: 'Italic', style: 'ITALIC' }
  ],
  display: [
    'INLINE_STYLE_BUTTONS',
    'BLOCK_TYPE_BUTTONS',
    'LINK_BUTTONS',
    'BLOCK_TYPE_DROPDOWN',
    'HISTORY_BUTTONS'
  ]
};
